import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { taskApi } from '../../api/task.api';
import { usePolling } from '../../hooks/useDraft';
import { useAuth } from '../../store/AuthContext';
import { useUI } from '../../store/UIContext';
import { deadlineCountdown } from '../../utils/taskHelpers';

/** Employees get a persistent pill (plus a toast / browser notification the
 * first time) for every unanswered task whose deadline is < 24h away. */
export default function TaskDeadlineNotifier() {
  const { user } = useAuth();
  const { addToast } = useUI();
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const shown = useRef(new Set());
  const enabled = ['simple_employee', 'manager_employee'].includes(user?.type);

  const poll = useCallback(async () => {
    try {
      const res = await taskApi.deadlineAlerts();
      const list = res.data?.alerts || [];
      setAlerts(list);
      const fresh = list.filter((a) => !shown.current.has(a.task_id));
      fresh.forEach((a) => shown.current.add(a.task_id));
      if (!fresh.length) return;
      const msg = fresh.length === 1
        ? `ددلاین تسک «${fresh[0].title}» نزدیک است (${deadlineCountdown(fresh[0].deadline)})`
        : `${fresh.length} تسک کمتر از یک روز تا ددلاین دارند`;
      addToast(msg, 'info', 8000);
      if (typeof Notification !== 'undefined') {
        if (Notification.permission === 'default') { try { await Notification.requestPermission(); } catch {} }
        if (Notification.permission === 'granted') {
          try { new Notification('پژواک CRM', { body: msg, tag: 'task-deadline' }); } catch {}
        }
      }
    } catch {}
  }, [addToast]);

  usePolling(poll, 60000, enabled);
  if (!enabled || !alerts.length) return null;
  const overdue = alerts.some((a) => a.overdue);

  return (
    <button
      onClick={() => navigate('/tasks?status=pending&sort=deadline')}
      title={alerts.map((a) => `${a.title} — ${deadlineCountdown(a.deadline)}`).join('\n')}
      style={{
        position: 'fixed', bottom: 20, left: 20, zIndex: 900, border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 16px', borderRadius: 999,
        background: overdue ? '#dc2626' : '#f59e0b', color: '#fff', fontFamily: 'inherit',
        fontSize: 13, fontWeight: 700, boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
      }}
    >
      ⏰ {alerts.length} تسک نزدیک ددلاین
    </button>
  );
}
